import React, { createContext } from 'react';
import useWatchBreakpoint from './useWatchBreakpoint';
import { Breakpoints } from './Breakpoint';

// get consumer context using 'useContext' hook
const BreakpointContext = createContext<Breakpoints>('xxlg');

const BreakpointProvider: React.FunctionComponent<Record<string, any>> & {
  Consumer: typeof BreakpointContext.Consumer;
  Context: typeof BreakpointContext;
} = ({ children }) => {
  const breakpoint = useWatchBreakpoint();

  return (
    <BreakpointContext.Provider value={breakpoint}>
      {children}
    </BreakpointContext.Provider>
  );
};

// another way to use consumer context
BreakpointProvider.Consumer = BreakpointContext.Consumer;
BreakpointProvider.Context = BreakpointContext;

export default BreakpointProvider;
